var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMentorBenefits3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.616,
    height: 86.819,
    viewBox: "0 0 81.616 86.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25635",
    "data-name": "Rectangle 25635",
    width: 81.616,
    height: 86.819,
    transform: "translate(0 0)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_88054",
    "data-name": "Group 88054",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308555",
    "data-name": "Path 308555",
    d: "M49.265,48.5h.19l-.19-.217Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308556",
    "data-name": "Path 308556",
    d: "M47.19,40.455,48.1,39.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_88053",
    "data-name": "Group 88053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88052",
    "data-name": "Group 88052",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_308557",
    "data-name": "Path 308557",
    d: "M47.189,41.383a.928.928,0,0,1-.754-1.467l.9-1.266a.928.928,0,0,1,1.509,1.08l-.9,1.265A.927.927,0,0,1,47.189,41.383Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308558",
    "data-name": "Path 308558",
    d: "M57.317,85.892H24.3V72.706A11.871,11.871,0,0,1,36.171,60.835h9.274A11.872,11.872,0,0,1,57.317,72.706Z",
    fill: "#fdf7f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308559",
    "data-name": "Path 308559",
    d: "M39.88,60.835H36.17A11.871,11.871,0,0,0,24.3,72.706V85.892h3.71V72.706A11.871,11.871,0,0,1,39.88,60.835",
    fill: "#fd930d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308560",
    "data-name": "Path 308560",
    d: "M50.519,75.123a1.205,1.205,0,1,1-1.206,1.206,1.206,1.206,0,0,1,1.206-1.206",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308561",
    "data-name": "Path 308561",
    d: "M31.1,75.123a1.205,1.205,0,1,1-1.206,1.206A1.206,1.206,0,0,1,31.1,75.123",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11052",
    "data-name": "Line 11052",
    y2: 4.926,
    transform: "translate(50.519 80.966)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11053",
    "data-name": "Line 11053",
    y2: 4.926,
    transform: "translate(31.097 80.966)",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308562",
    "data-name": "Path 308562",
    d: "M40.808,66.053a4.637,4.637,0,0,1-4.637-4.637V50.341h9.274V61.416A4.637,4.637,0,0,1,40.808,66.053Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308563",
    "data-name": "Path 308563",
    d: "M49.666,36.806H31.95V49.341a8.858,8.858,0,1,0,17.716,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308564",
    "data-name": "Path 308564",
    d: "M35.66,49.341V36.806H31.95V49.341A8.86,8.86,0,0,0,42.663,58a8.86,8.86,0,0,1-7-8.662",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308565",
    "data-name": "Path 308565",
    d: "M40.808,14.832,46.259,17.7l-1.041-6.07,4.411-4.3-6.1-.886L40.808.92,38.082,6.443l-6.095.886,4.411,4.3L35.357,17.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308566",
    "data-name": "Path 308566",
    d: "M42.562,4.473,40.807.92,38.083,6.443l-6.1.885,2.607,2.541,5.713-.83Z",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_11054",
    "data-name": "Line 11054",
    x2: 73.083,
    transform: "translate(4.266 85.892)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308567",
    "data-name": "Path 308567",
    d: "M80.688,63.7a.927.927,0,0,1-.927-.927V46.187a.927.927,0,1,1,1.854,0V62.772a.927.927,0,0,1-.927.927",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308568",
    "data-name": "Path 308568",
    d: "M80.688,41.607a.927.927,0,0,1-.927-.927V37.654a.927.927,0,1,1,1.854,0V40.68a.927.927,0,0,1-.927.927",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308569",
    "data-name": "Path 308569",
    d: "M71.414,71.119a.927.927,0,0,1-.927-.927V53.607a.927.927,0,1,1,1.854,0V70.192a.927.927,0,0,1-.927.927",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308570",
    "data-name": "Path 308570",
    d: "M71.414,49.026a.927.927,0,0,1-.927-.927V45.073a.927.927,0,1,1,1.854,0V48.1a.927.927,0,0,1-.927.927",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308571",
    "data-name": "Path 308571",
    d: "M.927,63.7A.927.927,0,0,1,0,62.772V46.187a.927.927,0,1,1,1.854,0V62.772a.927.927,0,0,1-.927.927",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308572",
    "data-name": "Path 308572",
    d: "M.927,41.607A.927.927,0,0,1,0,40.68V37.654a.927.927,0,0,1,1.854,0V40.68a.927.927,0,0,1-.927.927",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308573",
    "data-name": "Path 308573",
    d: "M10.2,71.119a.927.927,0,0,1-.927-.927V53.607a.927.927,0,1,1,1.854,0V70.192a.927.927,0,0,1-.927.927",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308574",
    "data-name": "Path 308574",
    d: "M10.2,49.026a.927.927,0,0,1-.927-.927V45.073a.927.927,0,1,1,1.854,0V48.1a.927.927,0,0,1-.927.927",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308575",
    "data-name": "Path 308575",
    d: "M35.4,11.952l-.959,5.589a.933.933,0,0,0,1.345.978l5.02-2.639,5.02,2.639a.96.96,0,0,0,1.346-.978l-.959-5.589,4.062-3.959a.934.934,0,0,0-.514-1.582L44.149,5.6,41.639.51a.933.933,0,0,0-1.663,0l-2.51,5.085-5.613.816a.934.934,0,0,0-.514,1.582Zm2.814-4.591a.928.928,0,0,0,.7-.507l1.894-3.838L42.7,6.854a.93.93,0,0,0,.7.507l4.235.615L44.57,10.963a.927.927,0,0,0-.266.821L45.027,16l-3.874-2.036a.833.833,0,0,0-.691,0L36.588,16l.723-4.218a.929.929,0,0,0-.267-.821L33.98,7.976Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308576",
    "data-name": "Path 308576",
    d: "M23.793,11.975l-5.612-.815-2.51-5.086a.934.934,0,0,0-1.664,0L11.5,11.16l-5.613.815a.934.934,0,0,0-.514,1.582l4.062,3.959L8.474,23.1a.933.933,0,0,0,1.345.978l5.02-2.639,5.02,2.639A.96.96,0,0,0,21.2,23.1l-.959-5.589,4.062-3.959a.934.934,0,0,0-.515-1.582",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308577",
    "data-name": "Path 308577",
    d: "M75.73,11.975l-5.612-.815-2.51-5.086a.934.934,0,0,0-1.664,0l-2.509,5.085-5.613.816a.934.934,0,0,0-.514,1.582l4.062,3.958-.959,5.59a.933.933,0,0,0,1.345.978l5.02-2.639,5.02,2.639a.96.96,0,0,0,1.346-.978l-.959-5.59,4.062-3.958A.934.934,0,0,0,75.73,11.975Z",
    fill: "#515255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_308578",
    "data-name": "Path 308578",
    d: "M77.349,84.965h-19.1V72.707a12.812,12.812,0,0,0-11.872-12.76V57.383a9.781,9.781,0,0,0,4.22-7.986,5.825,5.825,0,0,0,4.856-5.744c-.157-2.916.463-3.692-.6-7.48a8.1,8.1,0,0,0-5.639-5.431c-.4-1.387-1.609-2.931-4.85-3.542a25.23,25.23,0,0,0-6.963-.045,11.893,11.893,0,0,0-11.241,11.9v4.6A5.826,5.826,0,0,0,31.024,49.4a9.782,9.782,0,0,0,4.219,7.983v2.563A12.812,12.812,0,0,0,23.372,72.707V84.965H4.267a.928.928,0,1,0,0,1.855H77.35a.928.928,0,1,0,0-1.855M32.877,49.341v-7.4h.081A16.188,16.188,0,0,0,43.33,38.2a9.137,9.137,0,0,0,5.386,3.786l.022,7.353a7.931,7.931,0,1,1-15.861,0m11.641,9.053v3.022a3.71,3.71,0,0,1-7.42,0V58.394a9.833,9.833,0,0,0,7.42,0m6.928,26.571v-4a.927.927,0,0,0-1.855,0v4H32.024v-4a.927.927,0,0,0-1.855,0v4H25.227V72.707a10.954,10.954,0,0,1,10.031-10.9,5.563,5.563,0,0,0,11.1,0,10.954,10.954,0,0,1,10.032,10.9V84.965Z",
    fill: "#515255"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMentorBenefits3);
export default __webpack_public_path__ + "static/media/Mentor_Benefits_3.85ff7a568ec1f47445dbc6120a049be1.svg";
export { ForwardRef as ReactComponent };